import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateDialog } from '../../ui/action-creators';
import store from '../../index';
import { ConfirmTakedownRelease, TakedownRelease } from '../action-creators';
import { CONFIRM_TAKEDOWN_RELEASE } from '../actions';

export const confirmTakedownReleaseEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, ConfirmTakedownRelease>(CONFIRM_TAKEDOWN_RELEASE),
    map((action) => {
      return new CreateDialog(`TAKEDOWN.${action.releaseId}`, {
        open: true,
        title: `Confirm ${ action.isDelete ? 'Delete' : 'Takedown' }`,
        text: `Are you sure you want to ${ action.isDelete ? 'delete' : 'takedown' } ${action.title}? This can't be undone.`,
        actions: [
          { type: "primary", label: "No", value: false },
          { type: "secondary", label: "Yes", value: true },
        ],
        callback: (result) => result && store.dispatch(new TakedownRelease(action.artistId, action.releaseId, action.title))
      })
    })
  )